module.exports = __webpack_public_path__ + "media/images/icon-booster2-9641ebc0aa59f487c920ae049d13ef07.svg";